var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Query',{attrs:{"query":require('~/graphql/Article.gql').Articles,"limit":2,"variables":{ innovator: _vm.tags  },"moreButton":false},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var items = ref.items;
return [_c('AsymetricGrid',{ref:"grid",attrs:{"items":items},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
var ratio = ref.ratio;
return [_c('AppCard',{staticClass:"is-large",attrs:{"img":[{ srcset: item.thumb, type: 'image/jpg' }],"ratio":"1:1","url":("/articles/" + (item.slug)),"title":item.title}})]}}],null,true)})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }